import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ThemeService } from '@app/shared/services/theme.service';

@Component({
  selector: 'app-transcend-india',
  templateUrl: './transcend-india.component.html',
  styleUrl: './transcend-india.component.scss'
})
export class TranscendIndiaComponent implements OnInit{

  @ViewChild('speakerModal') speakerModal!: ElementRef;
  selectedSpeaker: any;
  currentTheme: string;
  defaultProfileImage = 'assets/images/thumb/no-thumb.jpeg';
  speakerInfo = [
    {
      name: 'Anubhav Singh',
      job_title: 'Co-founder - Callchimp.ai',
      company: '',
      thumbs: 'assets/images/thumb/anubhav-singh.jpg',
      description: 'Google Developer Expert in ML & GCP. Highly Talented Coder. Inspiring Community Builder. Exceptional Leader. Co-Founder of Callchimp.ai. TEDx Speaker. Anubhav Singh\'s portfolio just keeps growing. An avid learner of disruptive technologies, Anubhav has always been fueled by his passion for Computer Science. It didn\'t take long for India\'s tech community to start looking up to him for his ingenuity and technical prowess. The more complex his challenges are, the more innovative his solutions become.',
      facebook: '',
      twitter: '',
      linkedin: 'https://www.linkedin.com/in/xprilion/',
      mail: '',
      sort: 1
    },
    {
      name: 'Ravi Prakash',
      job_title: 'Chief Technology Officer, Beckn',
      company: '',
      thumbs: 'assets/images/thumb/Ravi_Prakash.png',
      description: 'Starting off as an Intern, Ravi Prakash steadily yet rapidly ascended in the IT ecosystem becoming a Lead Software Architect, and eventually the Principal Architect at Beckn Foundation. Now the Head of Architecture & Technology Ecosystem at FIDE (formerly Beckn Foundation), Ravi specializes in enabling planetary-scale digital transformation through public digital infrastructure via open protocols and specifications. He is also the Genesis author of the Beckn Protocol specification and designed the reference architecture for Beckn-enabled open commerce networks.',
      facebook: '',
      twitter: '',
      linkedin: 'https://www.linkedin.com/in/warpcoderavi/',
      mail: '',
      sort: 2
    },
    {
      name: 'Prasanth Nair',
      job_title: 'IAS, Spl Secretary, Agriculture, Govt of Kerala ',
      company: '',
      thumbs: 'assets/images/thumb/prasanth-nair-ias.jpg',
      description: 'Prasanth Nair is a Special Secretary to Government in the Department of Agriculture Development and Farmers’ Welfare in Kerala, India. He has over 17 years of experience in civil service and public administration, managing various sectors such as tourism, taxation, roads, water supply, and skill development. He holds an edX Verified Certificate for Exercising Leadership: Foundational Principles, which demonstrates his commitment to learning and enhancing his leadership skills. He is widely known as ‘Collector bro’ for his citizen-friendly and collaborative style of governance, especially during his tenure as the District Magistrate of Kozhikode. He has led two World Bank projects, Jalanidhi and KSTP, and has been recognized for his use of social media for governance and empowerment.',
      facebook: '',
      twitter: '',
      linkedin: 'https://www.linkedin.com/in/prasanth-nairias/',
      mail: '',
      sort: 4
    },
    {
      name: 'Nikhil Chandran',
      job_title: 'CEO of Tiltlabs',
      company: '',
      thumbs: 'assets/images/thumb/Nikhil_Chandran.jpg',
      description: 'A seasoned professional with over 15 years of experience in software development and project leadership, Nikhil is a high-level specialist in a range of emerging technologies. His immovable focus on Virtual and Augmented Reality (VR/AR), Artificial Intelligence (AI), and the Internet of Things (IoT). led him to be recognized as a Thought Leader and Evangelist in these areas. Nikhil has been committed to guiding academic institutions and businesses in navigating the intricate process of integrating these advanced technologies into their operations. In the process, he established TILTLABS - a leading organization that drives innovation and delivers powerful solutions to integrate the potential of spatial computing and XR.',
      facebook: '',
      twitter: '',
      linkedin: 'https://www.linkedin.com/in/nikhil-tiltlabs/',
      mail: '',
      sort: 10
    },
    {
      name: 'Joy Sebastian',
      job_title: 'Co-Founder & CEO, Techgentsia',
      company: '',
      thumbs: 'assets/images/thumb/joy-sebastian-techgentsia.jpg',
      description: 'A highly proficient Software Architect with decades of experience. An idealistic leader. An ardent researcher. A Co-Founder & CEO of Techgentsia Software Technologies. Joy Sebastian has tackled the toughest challenges in his career, giving him a wealth of experience and an immaculate sense of direction to identify every step various industries should take as technologies evolve. Joy has always been interested in trying something new in software development, which led him to start learning more about AI and its impact in the tech sector much earlier in his career.',
      facebook: '',
      twitter: '',
      linkedin: 'https://www.linkedin.com/in/joypsebastian/',
      mail: '',
      sort: 9
    },
    {
      name: 'Rahul Ramesh',
      job_title: 'Chief Technology Officer at Entri',
      company: '',
      thumbs: 'assets/images/thumb/rahul-ramesh-entri.jpg',
      description: 'A Specialist in Entrepreneurship, Rahul Ramesh is a Chief Technology Officer (CTO) at entri.me, one of the finest vernacular learning apps for jobs in India. He co-founded Codeyssus and worked as the company’s Chief Technology Officer before joining entri.me. His love for technologies drove him to understand the most disruptive technologies that could make and break businesses, and assess their impact on Indian businesses in today’s landscape. An avid reader and  a skilled developer himself, Rahul has been closely following the changing tides of  technological influences affecting industries worldwide.',
      facebook: '',
      twitter: '',
      linkedin: 'https://www.linkedin.com/in/thecoderdotin/',
      mail: '',
      sort: 11
    },
    {
      name: 'Jibu Elias',
      job_title: 'Mozilla Responsible Computing Fellow ',
      company: '',
      thumbs: 'assets/images/thumb/jibu-elias.jpg',
      description: 'Jibu Elias is an AI Ethicist, Activist, and Researcher with a diverse portfolio of roles. He is widely recognized as the foremost authority on India\'s AI ecosystem.Jibu is currently the Responsible Computing Challenge Lead(Fellow) for India at Mozilla.He is chief architect of INDIAai, where he held the position of Head of Content and Research for five years.His impactful work centers around the construction of a unified AI ecosystem in India, with a strong emphasis on mitigating the digital divide engendered by technologies like AI.Furthermore, he is actively engaged in the development of inclusive AI ethics and governance guidelines, ensuring that the benefits of AI are accessible to all segments of society.',
      facebook: '',
      twitter: '',
      linkedin: 'https://www.linkedin.com/in/jibuelias/',
      mail: '',
      sort: 3
    },
    {
      name: 'Sujith Unni',
      job_title: 'Regional Head, Nasscom',
      company: '',
      thumbs: 'assets/images/thumb/sujith-unni.jpg',
      description: 'Sujith is the Regional Head for NASSCOM in Kerala, the chief industry association for the IT-BPM sectors in India. He initiated the 10,000 Startups Warehouse in 2015, which ranks as the third warehouse in the country.He began his career with Confederation of Indian Industry (CII), to design a sustainable environment for the growth of the industry in Kerala, by partnering industry and government through advisory and consultative processes.Sujith is super dynamic and enthusiastic in creating a vigorous IT ecosystem in the state of Kerala and to aid IT-ITeS investments, thereby generating employment opportunities.',
      facebook: '',
      twitter: '',
      linkedin: 'https://www.linkedin.com/in/sujithunnims/',
      mail: '',
      sort: 19
    },
    {
      name: 'Deepu S Nath',
      job_title: 'Managing Director FAYA',
      company: '',
      thumbs: 'assets/images/thumb/deepu-s-nath-faya.jpg',
      description: 'Entrepreneur. Gamification Researcher. Technology Enthusiast. TiE Kerala Ecosystem Enabler. TedX Speaker. Deepu S. Nath is simply multi-faceted. A programmer turned entrepreneur and a technology evangelist, he is currently the Managing Director of FAYA India, the global technology center of Faya Corporation based out of California, USA. A strong advocate of enjoyable and exciting workplaces, Deepu architected an Intelligent Enterprise Gamification platform, a disruptive innovation in resource management strategy. Deepu had served as the Managing Director of DBG before it merged with FAYA Corporation. Displacing traditional concepts of employee management, in January 2014, DBG was listed on the group of 28 Key innovators in the world that embraced Gamification Culture, making it the only Indian company, alongside Google, Microsoft, IBM, Yahoo, etc..',
      facebook: '',
      twitter: '',
      linkedin: 'https://www.linkedin.com/in/deepusnath/',
      mail: '',
      sort: 20
    },{
      name: 'Dr Saji Gopinath',
      job_title: 'Vice Chancellor, Digital University of Kerala',
      company: '',
      thumbs: 'assets/images/thumb/saji-gopinadh.jpg',
      description: 'Saji Gopinath is the first Vice Chancellor of the newly formed Kerala University of Digital Sciences, Innovation and Technology (Digital University Kerala). Before assuming this position in 2000, he served as   Chief Executive Officer of Kerala Startup Mission for three years. He worked as Director of the Indian Institute of Information Technology and Management Kerala. He was associated with the Indian Institute of Management for over 17 years as its Dean (Academics), Dean (Development), and Professor in Operations Management. He was also the Director of TAPMI Manipal and the founding Dean of Bennett University, set up by Times of India. He also serves as visiting faculty to a few Universities in Europe and Australasia.',
      facebook: '',
      twitter: '',
      linkedin: 'https://www.linkedin.com/in/saji-gopinath-82774046/',
      mail: '',
      sort: 5
    },
    {
      name: 'Anoop Ambika',
      job_title: 'CEO, Kerala Startup Mission',
      company: '',
      thumbs: 'assets/images/thumb/anoop-ambika-kerala-startup-mission.jpg',
      description: 'Anoop P Ambika is a serial entrepreneur, organizer and a technology enthusiast. He is the co-founder of several technology/ environment startups and currently serves as the Chief Executive Officer of Kerala Startup Mission. Anoop worked with multi-nationals like GE, NEC, Lucent and Nortel in various managerial capacities before starting Kreara. When working with GE, he was also instrumental with the ISO and Six Sigma quality initiatives that were being undertaken by the company in the late 90’s. He underwent his management education in F W Olin Graduate School of Management at Wellesley, Massachusetts. He is also a post graduate in Computational Biology & Bioinformatics from University of Kerala.',
      facebook: '',
      twitter: '',
      linkedin: 'https://www.linkedin.com/in/anoopambika/',
      mail: '',
      sort: 6
    },
    {
      name: 'Dr Jayasankar Prasad',
      job_title: 'Director, DCSMAT',
      company: '',
      thumbs: 'assets/images/thumb/jayasankar-prasad.jpg',
      description: 'Dr. Jayasankar Prasad C (Dr Jay) is a management professional with extensive experience in organization leadership, policy formulation, project consulting, and implementation. He has managed senior management portfolios in both government and private organizations. He is also the Honorary Professor of Management and Entrepreneurship at the International Centre for Free and Open-Source Software (ICFOSS), as well as a Mentor and curriculum committee member for the Additional Skill Acquisition Program. He currently serves as the Director at DCSMAT Institutions, Kerala. He has noted professional stints in TCS , ICICI Kinfra and Avt McCormick, ICSFOSS, KSITM and Vizhinjam Port, and is recognised much for his work in building the startup Ecosystem in Kerala as the founder CEO of Kerala Startup Mission (KSUM).',
      facebook: '',
      twitter: '',
      linkedin: 'https://www.linkedin.com/in/jayasankar-prasad-c-b5459bb/',
      mail: '',
      sort: 7
    },
    {
      name: 'Mishal Abdullah',
      job_title: 'Kerala Lead, Beckn Open Collective',
      company: '',
      thumbs: 'assets/images/thumb/mishal.jpg',
      description: 'A badass programmer with a passion for Hacking things. Constantly building highly niche tools and working on projects that other developers fear to work. Currently working on a building Open Networks Using Beckn protcol and also building cool AI based products.',
      facebook: '',
      twitter: '',
      linkedin: '',
      mail: '',
      sort: 16
    },
    {
      name: 'Jofin Joseph',
      job_title: 'Partner, Pienza VC, Seattle',
      company: '',
      thumbs: 'assets/images/thumb/jofin.jpg',
      description: 'Jofin is a passionate entrepreneur and AI expert who is on a mission to help every business unlock the power of AI. He is the Founder and CEO of Totto Learning, a fresh perspective on early learning for children below 8 years, where self-learning from a screen is replaced by assisted learning, facilitated by the parent. With over 9 years of experience in data analytics, CRM, and web development, Jofin has successfully built and scaled three startups in the data and AI space. He was the GM for FullContact in India, where he grew and managed the India office and the Data Research function. He also co-founded Profoundis, a sales data intelligence tool that was acquired by FullContact. Jofin is a graduate of Microsoft Ventures and Blackbox accelerators, and has received multiple awards and honors for his contributions and innovations.',
      facebook: '',
      twitter: '',
      linkedin: 'https://www.linkedin.com/in/jofin/',
      mail: '',
      sort: 12
    },
    {
      name: 'Jijo Sunny',
      job_title: 'Co-Founder & CEO of Buy Me a Coffee',
      company: '',
      thumbs: 'assets/images/thumb/jijosunny.jpg',
      description: 'Co-founder & CEO of Buy Me a Coffee. Also created Bio Link (bio.link) which is the fastest growing mobile website builder in the world.',
      facebook: '',
      twitter: '',
      linkedin: 'https://www.linkedin.com/in/jijosunny/',
      mail: '',
      sort: 8
    },
    {
      name: 'Dr Athul Manuel',
      job_title: 'Medical Officer, District Palliative Care Centre, Ernakulam.',
      company: '',
      thumbs: 'assets/images/thumb/athul-joseph-manuel.jpg',
      description: 'Untamed doctor trying to find ‘Health Care’ through ‘Palliative Care’',
      facebook: '',
      twitter: '',
      linkedin: 'https://www.linkedin.com/in/athul-joseph-manuel-189200bb/',
      mail: '',
      sort: 14
    },
    {
      name: 'Sanjay Vijayakumar',
      job_title: 'Co-Founder of Pupilfirst',
      company: '',
      thumbs: 'assets/images/thumb/Sanjay.vijayakumar.jpg',
      description: 'Sanjay is a serial entrepreneur, co-author of India`s Student Startup Policy and Governing Board Member of Kerala Technical University.',
      facebook: '',
      twitter: '',
      linkedin: '',
      mail: '',
      sort: 13
    },
    {
      name: 'Bodhish Thomas',
      job_title: 'Co-Founder, Open Healthcare Network',
      company: '',
      thumbs: 'assets/images/thumb/Bodhish.jpg',
      description: 'A full stack developer/digital nomad with expertise in white labeled SaaS product architecture. Maintainer of multiple open-source projects and GitHub OSS Grant Winner 2021. He maintains the CoronaSafe Project which caters to improve the availability of healthcare resources across multiple states in India, He works full-time with Pupilfirst building an open learning management system and work with programs that teach coding to students across the country.',
      facebook: '',
      twitter: '',
      linkedin: 'https://www.linkedin.com/in/bodhish/?originalSubdomain=in',
      mail: '',
      sort: 15
    },
    // {
    //   name: 'Niyas Mohammed',
    //   job_title: 'CEO & Co-Founder,NeuralCraft',
    //   company: '',
    //   thumbs: 'assets/images/thumb/niyas.mohammed.jpg',
    //   description: 'Loves creating delightful user experiences powered by machine learning',
    //   facebook: '',
    //   twitter: '',
    //   linkedin: 'https://www.linkedin.com/in/niyasmohammed/',
    //   mail: '',
    //   sort: 19
    // },
    {
      name: 'Govind SB',
      job_title: 'Top 100 Coder, Product EngineerProduct Engineer Hoppscotch',
      company: '',
      thumbs: 'assets/images/thumb/Govind.s.b.jpg',
      description: 'Govind SB is an emerging and ambitious builder with a strong passion for large language models (LLMs). He is notable for his innovative products in the LLM field and has also provided expert AI consulting.',
      facebook: '',
      twitter: '',
      linkedin: '',
      mail: '',
      sort: 17
    },
    {
      name: 'Ekalevyan S',
      job_title: 'Top 100 Fellow, Assosicate School Mulearn, Ambitious Builder',
      company: '',
      thumbs: 'assets/images/thumb/Ekalavyan.jpg',
      description: 'Ekalaviyan is an 8th-grade student with expertise in the FERN stack. He has built many impressive products and is very passionate about his work, serving as an inspiration to everyone.',
      facebook: '',
      twitter: '',
      linkedin: '',
      mail: '',
      sort: 18
    },
  ];

  constructor(public themeService: ThemeService) {
    this.themeService.themes.subscribe(theme => {
      this.currentTheme = theme;
    });
  }

  ngOnInit() {
    this.assignDefaultSortingNumbers(this.speakerInfo);
    this.sortSpeakersBySortingNumber();
  }
  showModal(speaker: any) {
    this.selectedSpeaker = speaker;
    this.speakerModal.nativeElement.open = !this.speakerModal.nativeElement.open;
  }
  onProfilePicError(event: any) {
    event.target.src = this.defaultProfileImage;
  }
  sortSpeakersBySortingNumber() {
    this.speakerInfo.sort((a, b) => a.sort - b.sort);
  }
  assignDefaultSortingNumbers(items: any[]) {
    items.forEach((item, index) => {
      if (!item.hasOwnProperty('sort')) {
        item.sort = index + 1; // Set a default sorting number based on the index
      }
    });
  }

}
